import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { getLabelForEndorsementType } from './label-for-endorsement-type';

import {
  None,
  AddressServiceRequested,
  ForwardingServiceRequested,
  ChangeServiceRequested,
  ReturnServiceRequested,
} from '../../../../../../src/orders/other-shipping-options/constants/dhl-ecommerce/ancillary-endorsement';

const types = [None, AddressServiceRequested, ForwardingServiceRequested, ChangeServiceRequested, ReturnServiceRequested];

const EndorsementDropdownItems = ({ onEndorsementChange }) => {
  return types.map((endorsementType) => (
    <DropdownMenuItem key={endorsementType} name={endorsementType} onClick={onEndorsementChange}>
      {getLabelForEndorsementType(endorsementType)}
    </DropdownMenuItem>
  ));
};

EndorsementDropdownItems.propTypes = {
  onEndorsementChange: PropTypes.func.isRequired,
};

export default EndorsementDropdownItems;
